export default __webpack_public_path__ + "static/media/slide.3e0a942a.jpg";